<template>
	<div class="content">
		<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
		<div class="cont_title">课程详情</div>
		<div class="classify">
			<div class="classify_item" :class="active== item.id?'classify_itemac':''" @click="xuan(item.id)" v-for="(item,index) in renw" :key="index">{{item.title}}</div>
		</div>
		<div v-if="active == 1">
			<el-form  ref="formke" :model="form" :rules="rules" label-width="88px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="课程名称" prop="kecheng_name">
						  <el-input v-model="form.kecheng_name" placeholder="请输入课程名称" type="text"/>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<el-form-item>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="课程封面" prop="litpic">
							<el-upload class="avatar-uploaderS" :action="actionpost" :show-file-list="false" :headers="myHeaders"
							  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							  <img v-if="form.litpic" :src="form.litpic" class="avatar">
							  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload> 
						</el-form-item>
					</el-col>
					<el-button type="primary" @click="kecheng()">确 认</el-button>
					<!-- <el-col :span="6">
						<el-form-item label="课程院系" prop="department_id">
						  <el-select style="width: 100%;" v-model="form.department_id" placeholder="请选择课程院系">
						      <el-option
						        v-for="item in selist"
						        :key="item.id"
						        :label="item.department_name"
						        :value="item.id">
						      </el-option>
						  </el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="2">
						<el-form-item>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="6">
						<el-form-item label="授课老师" prop="teacher_id">
						  <el-select style="width: 100%;" v-model="form.teacher_id" placeholder="请选择授课老师">
						      <el-option
						        v-for="item in selist1"
						        :key="item.id"
						        :label="item.teacher_name"
						        :value="item.id">
						      </el-option>
						  </el-select>
						</el-form-item>
					</el-col> -->
				</el-row>
				<!-- <el-row>
				    <el-col :span="6">
				    	<el-form-item label="课程封面" prop="litpic">
							<el-upload class="avatar-uploaderS" :action="actionpost" :show-file-list="false" :headers="myHeaders"
							  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							  <img v-if="form.litpic" :src="form.litpic" class="avatar">
							  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload> 
				    	</el-form-item>
				    </el-col>
					<el-button type="primary" @click="kecheng()">确 认</el-button>
				</el-row> -->
			</el-form>
			
			<div class="jiaocai" v-if="id">
				<div class="jiaocai_title">课程内容</div>
				<div class="dhnav">
					<div class="dhnav_top">
						<div>课程导航</div>
						<img src="../../assets/img/jia1.png" alt="" @click="add_zhang()">
					</div>
					<div class="dhnav_yi" v-for="(item,index) in zjList" :key="index">
						<div class="dhnav_yi_top">
							<div class="zi" @click="edit_zhang(item.id,item.title)">{{item.title}}</div>
							<div class="tu">
								<img src="../../assets/img/jia1.png" alt="" @click="add_jie(item.id)">
								<img src="../../assets/img/jian.png" alt="" @click="del_zhang(item.id)">
							</div>
						</div>
						<div class="dhnav_item" :class="zjnav == itt.id?'dhnavact':''" v-for="(itt,inn) in item.jie" :key="itt.id">
							<div class="zi" @click="danji(itt.id)" @dblclick="shaungji(itt.id,itt.title)">{{itt.title}}</div>
							<div class="tu">
								<!-- <img src="../../assets/img/jia1.png" alt="" @click="add_jie(item.id)"> -->
								<img src="../../assets/img/jian.png" alt="" @click="del_jie(itt.id)">
							</div>
						</div>
					</div>
				</div>
				<div class="youcont">
					<div class="classify classify1">
						<div class="classify_item" :class="qiehuan== item.id?'classify_itemac':''" @click="xuan1(item.id)" v-for="(item,index) in jiaocc" :key="index">{{item.title}}</div>
					</div>
					<div v-if="qiehuan == 1">
						<editor v-model="zjiaocai" :height="500" style="margin-bottom: 20px;"/>
						<el-button type="primary" style="margin-left:auto;display: block;" @click="edit_jiaoc()">确认修改</el-button>
					</div>
					<div v-if="qiehuan == 3">
						<editor v-model="zjinsruction" :height="500" style="margin-bottom: 20px;"/>
						<el-button type="primary" style="margin-left:auto;display: block;" @click="edit_zhidao()">确认修改</el-button>
					</div>
					<div v-if="qiehuan == 2" class="kejian">
						<div style="width: 100%;margin-bottom: 30px;">
							<el-upload :action="actionpost" :show-file-list="false" :headers="myHeaders" 
							:on-progress="uploadProcess" :on-success="handleSuccess" :before-upload="beforeUpload">
							  <div class="zujuan_btn btn1">
							  	<img src="../../assets/img/tea2.png" alt="">
							  	<div>添加课件</div>
							  </div>
							</el-upload> 
							
							<el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
						</div>
						<div class="kejina_item" v-for="(item,index) in kejian_List" :key="index">
							<img class="kejina_item_pic" src="../../assets/img/fileup.png" alt="">
							<div>{{item.name}}.{{item.type}}</div>
							<div>{{item.size}}</div>
							<img class="kejina_item_close" src="../../assets/img/guan.png" alt="" @click="delkejian(item.id)">
						</div>
					</div>
					<div v-if="qiehuan == 4" class="renwu">
						<div class="renwunav">
							<div class="renwuitem" :class="renactive==item.id?'renwuitemac':''" 
							v-for="(item,index) in rennav" :key="index" @click="selrenw(item.id)">{{item.title}}</div>
						</div>
						<div class="renbox" v-if="renactive == 1">
							<div class="none" v-if="!renshow">
								<img src="../../assets/img/none.png" alt="">
								<div @click="addrenwu()">暂无任务，立即创建</div>
							</div>
							
							<div v-else>
								<div class="rentop">
									<div class="rentop_title">1、{{renwucont.renwu_title}}</div>
									<div class="rentop_r">
										<img src="../../assets/img/dele.png" alt="" @click="delrenwu()">
										<el-button type="primary" @click="editrenwu(renwucont.jie_id)">编辑任务</el-button>
									</div>
								</div>
								<div class="renfen">
									<div class="renfen_item">学习积分：{{renwucont.student_code}}积分</div>
									<div class="renfen_item">实操积分：{{renwucont.operation_code}}积分</div>
									<div class="renfen_item">答题积分：{{renwucont.answer_code}}积分</div>
									<div class="renfen_item">综合积分：{{renwucont.zonghe_code}}积分</div>
								</div>
								<div class="rendetail">任务详情：{{renwucont.renwu_desc}}</div>
							</div>
						</div>
						<div class="renbox" v-if="renactive == 2">
							<div class="zujuan_btn btn1" @click="opentimu()">
								<img src="../../assets/img/tea2.png" alt="">
								<div>添加题目</div>
							</div>
							<div class="left">
								
								<div class="left_title">一、单选题</div>
								<div class="left_item" v-for="(item,index) in shiti.danxuan" :key="index+'d'">
									<div class="left_item_title">
										<div>{{Number(index)+1}}、{{item.question_title}}</div>
										<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.kid)">
									</div>
									<div class="left_item_btm">
										<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
										v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
									</div>
									<!-- <el-radio-group v-model="item.cont">
									    <el-radio v-for="ite in item.option" :label="ite.id">{{ite.option_sn}}{{ite.option_title}}</el-radio>
									</el-radio-group> -->
								</div>
								
								<div class="left_title" style="margin-top: 50px;">二、多选题</div>
								<div class="left_item" v-for="(item,index) in shiti.duoxuan" :key="index+'c'">
									<div class="left_item_title">
										<div>{{Number(index)+1}}、{{item.question_title}}</div>
										<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.kid)">
									</div>
									<!-- <el-checkbox-group v-model="item.id" >
									    <el-checkbox v-for="(ite,ind) in item.option" :key="ind">{{ite.option_sn}}{{ite.option_title}}</el-checkbox>
									</el-checkbox-group> -->
									<div class="left_item_btm">
										<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
										v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
									</div>
								</div>
								
								<div class="left_title" style="margin-top: 50px;">三、判断题</div>
								<div class="left_item" v-for="(item,index) in shiti.panduan" :key="index+'b'">
									<div class="left_item_title">
										<div>{{Number(index)+1}}、{{item.question_title}}</div>
										<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.kid)">
									</div>
									<!-- <el-radio-group v-model="item.cont">
									    <el-radio v-for="ite in item.option" :label="ite.id">{{ite.option_title}}</el-radio>
									</el-radio-group> -->
									<div class="left_item_btm">
										<div class="left_item_btm_item" :class="ite.is_yes == 1?'left_item_btm_itemac':''" 
										v-for="ite in item.option">{{ite.option_sn}}、{{ite.option_title}}</div>
									</div>
								</div>
								
								<div class="left_title" style="margin-top: 50px;">四、简答题</div>
								<div class="left_item" v-for="(item,index) in shiti.yingyong" :key="index+'a'">
									<div class="left_item_title">
										<div>{{Number(index)+1}}、{{item.question_title}}</div>
										<img src="../../assets/img/dele.png" alt="" @click="delquestion(item.kid)">
									</div>
									<el-input style="margin-top: 20px;" v-model="item.answer.answer" readonly type="textarea" clearable :rows="6"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="active == 2">
			<el-table border :data="tableData1" v-loading="loading1" :header-cell-style="{background: '#F5F6F7'}">
				<el-table-column prop="id" label="#" align="center" width="80"/>
				<el-table-column prop="class_name" label="班级名称" align="center"/>
				<el-table-column prop="department_name" label="所属院系" align="center"/>
				<el-table-column  label="操作" align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.is_xuanzhong == 0" @click="editTeacher(scope.row)" type="text" size="small">添加</el-button>
						<el-button v-else @click="delTeacher(scope.row)" type="text" style="color:#f56c6c" size="small">移除</el-button>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="count" label="学生数量" align="center"/>
				<el-table-column prop="teacher_name" label="授课老师" align="center"/> -->
			</el-table>
			<!-- <div class="block" style="margin-top: 20px;text-align: center;">
				<el-pagination background  @current-change="handleCurrentChange1" 
				:current-page="currentPage1" layout="prev, pager, next" :total="total1"></el-pagination>
			</div> -->
		</div>
		<!-- 一级目录弹窗 -->
		<el-dialog :visible.sync="open" title="编辑章节名称" width="800px" append-to-body>
			<el-form  ref="zhangform" style="box-sizing: border-box;padding: 0 120px;" :model="zjform" label-width="78px">
				<el-row>
				    <el-form-item label="章节名称" prop="title">
				      <el-input v-model="zjform.title" placeholder="请输入章节名称" type="text"/>
				    </el-form-item>
				</el-row>
			</el-form>
		   <div slot="footer" class="dialog-footer" style="text-align: center;">
		     <el-button @click="cancel">取 消</el-button>
		   	<el-button type="primary" @click="submitman">提 交</el-button>
		   </div>
		</el-dialog>
		<!-- 二级弹窗 -->
		<el-dialog :visible.sync="open1" title="编辑章节名称" width="800px" append-to-body>
			<el-form  ref="zhangform1" style="box-sizing: border-box;padding: 0 120px;" :model="zjform1" label-width="78px">
				<el-row>
				    <el-form-item label="章节名称" prop="title">
				      <el-input v-model="zjform1.title" placeholder="请输入章节名称" type="text"/>
				    </el-form-item>
				</el-row>
			</el-form>
		   <div slot="footer" class="dialog-footer" style="text-align: center;">
		     <el-button @click="cancel">取 消</el-button>
		   	<el-button type="primary" @click="submitman1">提 交</el-button>
		   </div>
		</el-dialog>
	
		<!-- 创建编辑任务 -->
		<el-dialog :visible.sync="openren" :title="opentitle" width="800px" append-to-body>
			<el-form  ref="form" style="box-sizing: border-box;padding: 0 120px;" :model="renwucont" :rules="rules" label-width="78px">
				<el-row>
				    <el-form-item label="任务标题" prop="renwu_title">
				      <el-input v-model="renwucont.renwu_title" placeholder="请输入任务标题" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="学习积分" prop="student_code">
				      <el-input v-model="renwucont.student_code" placeholder="请输入学习积分" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="实操积分" prop="operation_code">
				      <el-input v-model="renwucont.operation_code"  placeholder="请输入实操积分" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="答题积分" prop="answer_code">
				      <el-input v-model="renwucont.answer_code" placeholder="请输入答题积分" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="综合积分" prop="zonghe_code">
				      <el-input v-model="renwucont.zonghe_code" placeholder="请输入综合积分" type="text"/>
				    </el-form-item>
				</el-row>
				<el-row>
				    <el-form-item label="任务详情" prop="renwu_desc">
				      <el-input v-model="renwucont.renwu_desc" type="textarea" :rows="4" placeholder="请输入任务详情"/>
				    </el-form-item>
				</el-row>
			</el-form>
		  
		   <div slot="footer" class="dialog-footer" style="text-align: center;">
		     <el-button @click="cancelren">取 消</el-button>
		   	<el-button type="primary" @click="submitren">提 交</el-button>
		   </div>
		</el-dialog>
	
		<!-- 添加试题 -->
		<el-dialog :visible.sync="openti" title="添加试题" width="1000px" append-to-body>
			<el-form :model="queryParams2" :inline="true" label-width="88px">
				<el-form-item label="试题名称">
				  <el-input  v-model="queryParams2.keywords" placeholder="请输入试题名称" type="text"/>
				</el-form-item>
				<el-form-item label="试题类型">
				  <el-select style="width: 100%;" v-model="queryParams2.question_type" placeholder="请选择试题类型">
					  <el-option
						v-for="item in selist2"
						:key="item.id"
						:label="item.title"
						:value="item.id">
					  </el-option>
				  </el-select>
				</el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="select_kecheng_zhang_jie_question()">搜 索</el-button>
			</el-form>
			<el-table style="width: 100%;margin-top: 30px;" border :data="tableData2"
			 @selection-change="handleSelectionChange" :header-cell-style="{background: '#F5F6F7'}" v-loading="loading2">
				<el-table-column type="selection" width="55" align="center" />
				<el-table-column prop="id" label="ID" width="55" align="center"/>
				<el-table-column prop="question_title" label="试题名称" width="300" align="center"/>
				<el-table-column label="试题类型" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.question_type == 1">单选</span>
						<span v-if="scope.row.question_type == 2">多选</span>
						<span v-if="scope.row.question_type == 3">判断</span>
						<span v-if="scope.row.question_type == 4">应用</span>
					</template>
				</el-table-column>
				<el-table-column prop="kecheng_name" label="课程名称" align="center"/>
				<el-table-column prop="add_time" label="添加时间" align="center"/>
				<!-- <el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<span class="blue" @click="xuanze(scope.row)">添加</span>
					</template>
				</el-table-column> -->
			</el-table>
			<div class="block" style="margin-top: 20px;text-align: center;">
				<el-pagination background layout="prev, pager, next"  
				@current-change="handleCurrentChange2" :current-page="currentPage2" :total="total2"></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: center;">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {kecheng_details,add_kecheng,edit_kecheng,teacher_list,department_list,kecheng_banji,
		mulu,jie_details,add_zhang,edit_zhang,delete_zhang,add_jie,edit_jie,delete_jie,
		kejianlist,add_jie_kejian,deletekejian,renwu_details,add_renwu,edit_renwu,delete_renwu,
		kecheng_zhang_jie_question_list,delete_kecheng_question,select_kecheng_zhang_jie_question,
		add_kecheng_zhang_jie_question,add_kecheng_banji1,delete_kecheng_banji1
} from "../../api/new.js";
var token = localStorage.getItem('token') // 获取token	
	export default {
		data() {
			return {
				check:'',
				radio:'',
				
				open:false,
				loading: false,
				selist:[],
				selist1:[],
				form:{
					kecheng_name:'',
					litpic:'',
					// teacher_id:'',
					// department_id:'',
				},
				rules:{
					kecheng_name: [{ required: true, message: "请输入课程名称", trigger: "blur" } ],
					// department_id: [{ required: true, message: "请选择课程院系", trigger: "blur" } ],
					// teacher_id: [{ required: true, message: "请选择授课老师", trigger: "blur" } ],
					litpic: [{ required: true, message: "请上传课程封面", trigger: "blur" } ]
				},
				active:1,
				renw:[{id:1,title:'课程详情'},{id:2,title:'班级列表'}],
				jiaocc:[{id:1,title:'教材'},{id:2,title:'课件'},{id:3,title:'实验指导书'},{id:4,title:'实训任务'}],
				qiehuan:1,
				actionpost: 'http://ws-nocode.com:81/login.php/Uploadfile/Uploadfile',
				myHeaders: { token: token },
				id:'',
				loading1: true,
				tableData1: [],
				queryParams1:{
					keywords:'',
					limit:10,
					page:1,
					kecheng_id:'',
				},
				total1: 0,
				currentPage1: 1,
				
				zjnav:0,
				zjinsruction:'',
				zjiaocai:'',
				
				zjList:[],//章节列表
				open:false,
				zjform:{
					title:''
				},
				open1:false,
				zjform1:{
					title:''
				},
				kejian_List:[],//课件列表
				loadProgress: 0, // 动态显示进度条
				progressFlag: false, // 关闭进度条
				
				rennav:[{id:1,title:'实训任务'},{id:2,title:'实训题目'}],
				renactive:1,
				openren:false,
				opentitle:'创建任务',
				editt:false,
				renshow:false,
				renwucont:{
					jie_id:'',
					renwu_title:'',
					renwu_desc:'',
					student_code:'',
					operation_code:'',
					answer_code:'',
					zonghe_code:'',
				},
				shiti:[],
				
				selist2:[{id:1,title:'单选'},{id:2,title:'多选'},{id:3,title:'判断'},{id:4,title:'应用'},{id:5,title:'全部'}],
				openti:false,
				loading2: false,
				tableData2: [],
				queryParams2:{
					keywords:'',
					limit:10,
					page:1,
					question_type:'',
					jie_id:'',
				},
				total2: 0,
				currentPage2: 1,
			};
		},
		mounted() {
			this.getList()
			if(this.$route.query.id){
				this.id = this.$route.query.id
				this.queryParams1.kecheng_id = this.$route.query.id
				this.active = this.$route.query.act
				this.getList1()
				this.kecheng_details()
				this.mulu()
			}
		},
		methods: {
			//添加班级
			editTeacher(row){
				var _this = this
				var data = { 
					kecheng_id:_this.id,
					banji_id:row.id,
					}
				add_kecheng_banji1(data).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						_this.getList1()
					} else {
						this.$message.error(res.msg);
					}
				  }).catch((err) => {
						console.log(err);
				  });
			},
			//删除班级
			delTeacher(row){
				var _this = this
				var data = {
					kecheng_id:_this.id,
					banji_id:row.id,
					}
				// this.$confirm('您确定要移除该课程吗？', "提示", {
				// 	confirmButtonText: "确定",
				// 	cancelButtonText: "取消",
				// 	type: "warning",
				// 	}).then(() => {
						delete_kecheng_banji1(data).then((res) => {
							if (res.code == 0) {
								_this.$message.success(res.msg);
								_this.getList1()
							} else {
								this.$message.error(res.msg);
							}
						  }).catch((err) => {
								console.log(err);
						  });
					// }).catch(() => {});
			},
			//试题列表
			kecheng_zhang_jie_question_list(id){
				var _this = this
				var data1 = { jie_id:id }
				kecheng_zhang_jie_question_list(data1).then((res) => {
					if (res.code == 0) {
						_this.shiti = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})  
			},
			//删除试题
			delquestion(id){
				var _this = this
				var data = { id:id }
				this.$confirm('您确定要删除试题吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					delete_kecheng_question(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.kecheng_zhang_jie_question_list(_this.zjnav)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//未添加的试题列表
			select_kecheng_zhang_jie_question(id){
				var _this = this
				this.loading2 = true
				select_kecheng_zhang_jie_question(this.queryParams2).then((res) => {
					this.loading2 = false
					if (res.code == 0) {
						this.tableData2 = res.data
						this.total2 = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading2 = false
				});	
			},
			//选择试题弹窗
			opentimu(){
				this.openti = true
				this.select_kecheng_zhang_jie_question()
			},
			//将试题添加到列表
			submitForm(){
				var _this = this
				if(this.ids.length > 0){
					var idd = this.ids.toString()
					var data = {
						jie_id:this.zjnav,
						question_id:idd,
					}
					add_kecheng_zhang_jie_question(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							// _this.select_kecheng_zhang_jie_question()
							_this.openti = false
							_this.kecheng_zhang_jie_question_list(_this.zjnav)
						} else {
							this.$message.error(res.msg);
						} 
					})
				}
			},
			//实训任务切换
			selrenw(id){
				if(this.renactive != id){
					this.renactive = id
				}
			},
			//实训任务详情
			renwu_details(id){
				var _this = this
				var data1 = { jie_id:id }
				renwu_details(data1).then((res) => {
					if (res.code == 0) {
						_this.renwucont = res.data
						_this.renshow = true
					}else if(res.code == 2){
						_this.renwucont = {}
						_this.renshow = false
					} else {
						this.$message.error(res.msg);
					} 
				})  
			},
			//新增打开
			addrenwu(){
				this.renwucont = {}
				this.renwucont.jie_id = this.zjnav
				this.editt = false
				this.openren = true
				this.opentitle ='创建任务'
			},
			//编辑任务打开
			editrenwu(e){
				this.openren = true
				this.editt = true
				this.opentitle ='编辑任务'
			},
			//取消
			cancelren(){
				this.renwucont = {}
				this.openren = false
				this.editt = false
			},
			//新增编辑确定
			submitren(){
				var _this = this
				if(this.editt){
					//修改
					edit_renwu(this.renwucont).then((res) => {
						if (res.code == 0) {
							_this.$message.success('任务修改成功');
							_this.cancelren()
							_this.renwu_details(_this.zjnav)
						} else {
							_this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
				}else{
					// 新增
					add_renwu(this.renwucont).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.cancelren()
							_this.renwu_details(_this.zjnav)
						} else {
							_this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						console.log(err);
					});
				}
			},
			//删除实训任务
			delrenwu(){
				var _this = this
				var data = { jie_id:_this.zjnav }
				this.$confirm('您确定要删除实训任务吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					delete_renwu(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.renwu_details(_this.zjnav)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//修改教材富文本
			edit_jiaoc(){
				var _this = this
				var data = {
					jie_id:this.zjnav,
					jiaocai:this.zjiaocai,
				}
				edit_jie(data).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						// _this.jie_details(_this.zjnav)
					} else {
						_this.$message.error(res.msg);
					}
				})
			},
			//修改实验指导书富文本
			edit_zhidao(){
				var _this = this
				var data = {
					jie_id:this.zjnav,
					insruction:this.zjinsruction,
				}
				edit_jie(data).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						// _this.jie_details(_this.zjnav)
					} else {
						_this.$message.error(res.msg);
					}
				})
			},
			//节点单击切换
			danji(id){
				var _this = this
				if(this.zjnav != id){
					_this.zjnav = id
					_this.queryParams2.jie_id = id
					_this.jie_details(_this.zjnav)
					_this.kejianlist(_this.zjnav)
					_this.renwu_details(_this.zjnav)
					_this.kecheng_zhang_jie_question_list(_this.zjnav)
					
				}
			},
			//节点双击弹出修改
			shaungji(id,title){
				this.zjform1.jie_id = id
				this.zjform1.title = title
				this.open1 = true
			},
			//修改节名称
			submitman1(){
				var _this = this
				edit_jie(this.zjform1).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						_this.cancel()
						_this.mulugai()
					} else {
						_this.$message.error(res.msg);
					}
				})
			},
			//课程详情
			kecheng_details(){
				var _this = this
				var data = { id:this.id }
				kecheng_details(data).then((res) => {
					if (res.code == 0) {
						_this.form = res.data
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			//章节目录
			mulu(){
				var _this = this
				var data1 = { kecheng_id:this.id }
				mulu(data1).then((res) => {
					if (res.code == 0) {
						_this.zjList = res.data
						_this.zjnav = res.data[0].jie[0].id
						_this.queryParams2.jie_id = res.data[0].jie[0].id
						_this.jie_details(_this.zjnav)
						_this.kejianlist(_this.zjnav)
						_this.renwu_details(_this.zjnav)
						_this.kecheng_zhang_jie_question_list(_this.zjnav)
					} else {
						this.$message.error(res.msg);
					} 
				})  
			},
			//修改名字后刷新章节
			mulugai(){
				var _this = this
				var data1 = { kecheng_id:this.id }
				mulu(data1).then((res) => {
					if (res.code == 0) {
						_this.zjList = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})  
			},
			//节详情
			jie_details(id){
				var _this = this
				var data1 = { jie_id:id }
				jie_details(data1).then((res) => {
					if (res.code == 0) {
						// _this.zjList = res.data
						 _this.zjinsruction = res.data.insruction
						 _this.zjiaocai = res.data.jiaocai
					} else {
						this.$message.error(res.msg);
					} 
				}) 
			},
			//章节课件列表
			kejianlist(id){
				var _this = this
				var data1 = { jie_id:id }
				kejianlist(data1).then((res) => {
					if (res.code == 0) {
						_this.kejian_List = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})  
			},
			//上传课件之后
			handleSuccess(res, file) {
			  if (res.code == 0) {
				this.add_jie_kejian(res.file_oldname,res.file_size,res.file_type,res.url)
			  } else {
			    this.$message.error(res.msg);
			  }
			},
			//上传课件中
			uploadProcess(event, file, fileList){
				this.progressFlag = true; // 显示进度条
				  this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
				  if (this.loadProgress >= 100) {
					  this.loadProgress = 100
					  setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
				  }
			},
			//上传课件之前
			beforeUpload(file) {
			  // const isJPG = file.type === 'image/jpeg';
			  // const isLt2M = file.size / 1024 / 1024 < 2;
			},
			//上传课件
			add_jie_kejian(name,size,type,url){
				var _this = this
				var data = {
					jie_id:_this.zjnav,
					name:name,
					size:size,
					type:type,
					url:url,
				}
				add_jie_kejian(data).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						_this.kejianlist(_this.zjnav)
					} else {
						_this.$message.error(res.msg);
					}
				})
			},
			//删除课件
			delkejian(id){
				var _this = this
				var data = { id:id }
				this.$confirm('您确定要删除该课件吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					deletekejian(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.kejianlist(_this.zjnav)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//新增章
			add_zhang(){
				var _this = this
				var data = {kecheng_id:this.id}
				this.$confirm('您确定要增加一级目录吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					add_zhang(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.mulu()
						} else {
							_this.$message.error(res.msg);
						}
					})
				}).catch(() => {});
			},
			//修改章
			edit_zhang(id,title){
				this.zjform.zhang_id = id
				this.zjform.title = title
				this.open = true
			},
			//取消
			cancel(){
				this.open = false
				this.open1 = false
				this.openti = false
			},
			//修改章名称
			submitman(){
				var _this = this
				edit_zhang(this.zjform).then((res) => {
					if (res.code == 0) {
						_this.$message.success(res.msg);
						_this.cancel()
						_this.mulugai()
					} else {
						_this.$message.error(res.msg);
					}
				})
			},
			//删除章
			del_zhang(id){
				var _this = this
				var data = { zhang_id:id }
				this.$confirm('您确定要删除该章节吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					delete_zhang(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.mulu()
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//新增节
			add_jie(id){
				var _this = this
				var data = {zhang_id:id}
				this.$confirm('您确定要增加二级目录吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					add_jie(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.mulu()
						} else {
							_this.$message.error(res.msg);
						}
					})
				}).catch(() => {});
			},
			//删除节
			del_jie(id){
				var _this = this
				var data = { jie_id:id }
				this.$confirm('您确定要删除该章节吗？', "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					delete_jie(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							_this.mulu()
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}).catch(() => {});
			},
			//列表
			getList(){
				var _this = this
				var data = {limit:1000,page:1}
				//教师列表
				teacher_list(data).then((res) => {
					if (res.code == 0) {
						this.selist1 = res.data
					}
				})
				//院系列表
				department_list(data).then((res) => {
					if (res.code == 0) {
						this.selist = res.data
					}
				})
			},
			//课程班级列表
			getList1(){
				var _this = this
				this.loading1 = true
				kecheng_banji(this.queryParams1).then((res) => {
					this.loading1 = false
					if (res.code == 0) {
						this.tableData1 = res.data
						this.total1 = res.total
					} else {
						this.$message.error(res.msg);
					} 
				})
				.catch((err) => {
					this.loading1 = false
				});	
			},
			//添加，修改课程信息
			kecheng(){
				var _this = this
				this.$refs.formke.validate(async (valid) => {
				    if (!valid) return;
					if(_this.id){
						edit_kecheng(this.form).then((res) => {
							if (res.code == 0) {
								this.$message.success('修改成功');
								_this.kecheng_details()
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							console.log(err);
						});
					}else{
						add_kecheng(this.form).then((res) => {
							if (res.code == 0) {
								this.$message.success('添加成功');
								_this.id = res.kecheng_id
								_this.kecheng_details()
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							console.log(err);
						});
					}
				  
				});
			},
			handleAvatarSuccess(res, file) {
			  if (res.code == 0) {
				  this.form.litpic = res.url
			  } else {
			    this.$message.error(res.msg);
			  }
			},
			beforeAvatarUpload(file) {
			  const isJPG = file.type === 'image/jpeg';
			  const isLt2M = file.size / 1024 / 1024 < 2;
			},
			
			xuan(id){
				if(this.active != id){
					this.active = id
				}
			},
			xuan1(id){
				if(this.qiehuan != id){
					this.qiehuan = id
				}
			},
			back(){
				this.$router.go(-1);
			},
			//班级列表上一页，下一页
			handleCurrentChange1(currentPage) {
				this.queryParams1.page = currentPage;
				this.currentPage1 = currentPage;
				this.getList1()
			},
			// 多选框选中数据
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
			},
			//未选中试题列表上一页，下一页
			handleCurrentChange2(currentPage) {
				this.queryParams2.page = currentPage;
				this.currentPage2 = currentPage;
				this.select_kecheng_zhang_jie_question()
			}
		},
	};
</script>
<style>
.avatar-uploaderS .el-upload {
	  border: 1px dashed #d9d9d9;
	  border-radius: 6px;
	  cursor: pointer;
	  overflow: hidden;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  width: 100px !important;
	  height: 100px !important;
	}
	
	.avatar-uploaderS .el-upload:hover {
	  border-color: #409EFF;
	}	
</style>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.blue{
	color: #007AFF;
	cursor: pointer;
}
.content{
	width: 100%;
	min-width: 1200px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	
	.classify{
		width: 320px;
		height: 56px;
		background: #FFFFFF;
		border: 1px solid #007AFF;
		border-radius: 25px;
		overflow: hidden;
		display: flex;
		cursor: pointer;
		margin: 30px 0;
		.classify_item{
			width: 160px;
			height: 56px;
			font-size: 18px;
			color: #007AFF;
			line-height: 56px;
			text-align: center;
			border-right: 1px solid #007AFF;
			transition: 0.3s;
		}
		.classify_item:last-child{
			border: none;
		}
		.classify_itemac{
			background: #007AFF;
			color: #FFFFFF;
			transition: 0.3s;
		}
	}
	.classify1{
		width: 640px;
		margin: 0;
		margin-bottom: 30px;
	}
	.jiaocai{
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.jiaocai_title{
			width: 100%;
			font-size: 20px;
			font-weight: bold;
			color: #333333;
			line-height: 48px;
			margin-bottom: 20px;
		}
		.dhnav{
			width: 260px;
			background: #F7F7F7;
			min-height: 500px;
			.dhnav_top{
				width: 260px;
				height: 56px;
				background: #F7F7F7;
				text-align: center;
				line-height: 56px;
				font-size: 20px;
				font-weight: 500;
				color: #333333;
				border-bottom: 2px solid #FFFFFF;
				position: relative;
				img{
					width: 24px;
					height: 24px;
					cursor: pointer;
					position: absolute;
					top:16px;
					right: 24px;
				}
			}
			.dhnav_yi{
				width: 260px;
				background: #F7F7F7;
				.dhnav_yi_top{
					width: 260px;
					height: 48px;
					background: #F7F7F7;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 24px;
					.zi{
						width: 140px;
						font-size: 18px;
						color: #333333;
						line-height: 18px;
						cursor: pointer;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					.tu{
						display: flex;
						align-items: center;
						justify-content: center;
						img{
							width: 24px;
							height: 24px;
							margin-left: 5px;
							cursor: pointer;
						}
					}
					
				}
				.dhnav_item{
					width: 260px;
					height: 48px;
					background: #F7F7F7;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 24px 0 34px;
					// border-left: 2px solid #333333;
					.zi{
						width: 140px;
						font-size: 18px;
						color: #333333;
						line-height: 18px;
						cursor: pointer;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					.tu{
						display: flex;
						align-items: center;
						justify-content: center;
						img{
							width: 24px;
							height: 24px;
							margin-left: 5px;
							cursor: pointer;
						}
					}
				}
				.dhnavact{
					background: #EBEBEB;
					border-left: 4px solid #007AFF;
					
					.zi{
						color: #007AFF;
					}
				}
			}
		}
		.youcont{
			flex: 1;
			margin-left: 60px;
			.kejian{
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				
				.kejina_item{
					width: 48%;
					height: 56px;
					padding: 0 20px;
					background: #F5F5F5;
					margin-bottom: 20px;
					display: flex;
					align-items: center;
					.kejina_item_pic{
						width: 28px;
						height: 34px;
					}
					div{
						font-size: 16px;
						color: #333333;
						margin-left: 30px;
					}
					.kejina_item_close{
						width: 24px;
						height: 24px;
						cursor: pointer;
						margin-left: auto;
					}
				}
			}
			.renwu{
				width: 100%;
				.renwunav{
					display: flex;
					margin-bottom: 20px;
					.renwuitem{
						font-size: 20px;
						font-weight: 500;
						color: #333333;
						line-height: 48px;
						border-bottom: 4px solid #FFFFFF;
						margin-right: 100px;
						cursor: pointer;
						transition: 0.3s;
					}
					.renwuitemac{
						color: #007AFF;
						border-bottom: 4px solid #007AFF;
						transition: 0.3s;
					}
				}
				.renbox{
					width: 100%;
					.none{
						margin: 50px auto;
						img{
							width: 100px;
							height: 100px;
							display: block;
							margin: 0 auto;
						}
						div{
							font-size: 20px;
							color: #333333;
							line-height: 48px;
							text-align: center;
							cursor: pointer;
						}
					}
					.rentop{
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						.rentop_title{
							font-size: 20px;
							color: #333333;
							line-height: 48px;
						}
						.rentop_r{
							display: flex;
							align-items: center;
							img{
								width: 24px;
								height: 24px;
								cursor: pointer;
								margin-right: 15px;
							}
						}
						
					}
					.renfen{
						width: 100%;
						height: 40px;
						background: #F7F7F7;
						margin-top: 10px;
						display: flex;
						align-items: center;
						padding: 0 15px;
						.renfen_item{
							font-size: 18px;
							color: #333333;
							margin-right: 50px;
						}
					}
					.rendetail{
						width: 100%;
						margin-top: 20px;
						font-size: 18px;
						line-height: 36px;
						color: #333333;
					}
					.left{
						.left_title{
							width: 100%;
							font-size: 18px;
							font-weight: 500;
							color: #333333;
							line-height: 36px;
						}
						.left_item{
							width: 100%;
							margin-top: 20px;
							.left_item_title{
								width: 80%;
								display: flex;
								justify-content: space-between;
								div{
									flex: 1;
									font-size: 18px;
									font-weight: 500;
									color: #333333;
									line-height: 36px;
								}
								img{
									width: 30px;
									height: 30px;
									margin-left: 60px;
									cursor: pointer;
								}
							}
							.left_item_btm{
								width: 80%;
								display: flex;
								flex-wrap: wrap;
								padding-left: 25px;
								.left_item_btm_item{
									margin-top: 15px;
									margin-right: 25px;
									font-size: 18px;
								}
								.left_item_btm_itemac{
									color: #007AFF;
								}
							}
							
						}
						
					}
				}
			}
			
		}
	}
	
}	
.zujuan_btn{
	width: 140px;
	height: 44px;
	background: #4076F3;
	border-radius: 10px;
	font-size: 16px;
	color: #FFFFFF;
	line-height: 44px;
	text-align: center;
	cursor: pointer;
	margin-left: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	img{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
}
.btn1{
	background: #ED7F26;
}
.btn2{
	background: #E13049;
}
.zujuan_btn:hover{
	opacity: 0.7;
}
.zujuan_btn:active{
	opacity: 0.9;
}
.el-radio {
		margin-top: 15px;
		margin-left: 15px;
	}
	.el-checkbox{
		margin-top: 15px;
		margin-left: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/kecheng/addKe.vue